import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = [
        "gtmTypeSelectInput",
        "templateBelongsToWrapper",
        "templateBelongsToInput"
    ];

    typeSelected() {
        const selectedType = this.gtmTypeSelectInputTarget.value

        if (selectedType == "custom_template") {
            this.templateBelongsToWrapperTarget.classList.remove("hidden")
        } else {
            this.templateBelongsToWrapperTarget.classList.add("hidden")
            this.templateBelongsToInputTarget.value = null
        }
    }

}